import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [state, setState] = useState({ status: "polling", attempts: 0 });

  useEffect(() => {
    if (!session_id) { setState({ status: "error" }); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        if (data.payment_status === "paid") { setState({ status: "paid", data }); return; }
        if (data.payment_status === "failed" || data.payment_status === "expired") { setState({ status: "failed" }); return; }
        if (attempts >= 15) { setState({ status: "timeout" }); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attempts >= 15) setState({ status: "error" });
        else setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [session_id]);

  return (
    <main data-testid="payment-success-page" className="bg-[#F6F4EE] min-h-screen text-[#0D1F2D]">
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        {state.status === "polling" && (
          <>
            <Loader2 size={48} className="animate-spin text-[#0F6E5B] mx-auto" />
            <h1 className="font-display text-4xl font-bold mt-6">Confirmăm plata…</h1>
            <p className="mt-3 text-[#52616B]">Verificăm statusul tranzacției, durează câteva secunde.</p>
          </>
        )}
        {state.status === "paid" && (
          <>
            <CheckCircle2 size={64} className="text-[#0F6E5B] mx-auto" />
            <h1 className="font-display text-4xl font-bold mt-6">Plată confirmată.</h1>
            <p className="mt-3 text-[#52616B]">Creditele au fost adăugate pe emailul tău.</p>
            <div className="mt-8 flex gap-3 justify-center">
              <Link to="/istoric" className="bg-[#0D1F2D] text-[#F6F4EE] px-6 h-11 rounded-sm font-medium flex items-center hover:bg-[#0F6E5B] transition-colors">Vezi creditele</Link>
              <Link to="/evaluare" className="border border-[#0D1F2D] px-6 h-11 rounded-sm font-medium flex items-center hover:bg-[#0D1F2D] hover:text-[#F6F4EE] transition-colors">Evaluare nouă</Link>
            </div>
          </>
        )}
        {(state.status === "failed" || state.status === "error" || state.status === "timeout") && (
          <>
            <XCircle size={64} className="text-[#0F6E5B] mx-auto" />
            <h1 className="font-display text-4xl font-bold mt-6">Nu s-a putut confirma plata.</h1>
            <p className="mt-3 text-[#52616B]">Dacă suma a fost reținută, te rugăm să ne scrii pentru verificare manuală.</p>
            <Link to="/preturi" className="mt-8 inline-flex bg-[#0D1F2D] text-[#F6F4EE] px-6 h-11 rounded-sm font-medium items-center">Înapoi la planuri</Link>
          </>
        )}
      </div>
    </main>
  );
}
